<template>
  <div class="select-tree">
    <div
      v-if="options.length"
      class="tree-data-desc"
      @click="showSelectTreePicker"
    >
      <span
        v-if="treeDataDesc"
        class="name fs-black"
      >{{ treeDataDesc }}</span>
      <span
        v-else
        class="name"
      >{{ $t('message["855"]') }}</span>
      <i class="iconfont iconicon-test18" />
    </div>
    <cube-input
      v-if="enableinput"
      v-model="data.fieldvalue.input"
      :placeholder="enterPlaceholder"
      class="border-top-1px"
      @input="handleInput"
    />
    <select-tree-pop
      v-if="options.length"
      ref="selectTreePicker"
      :options="options"
      :default-value="defaultVal"
      @getDefault="defaultHandler"
      @cancel="cancelHandler"
      @confirm="confirmHandler"
    />
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>

<script>
import SelectTreePop from '@/components/mobile/TreeSelect/TreeSelectPop'
/* import Vue from 'vue'
import { createAPI } from 'cube-ui'
createAPI(Vue, SelectTreePop, ['select', 'cancel', 'confirm'], true) */

export default {
  components: {
    SelectTreePop
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      defaultVal: '',
      selectedList: [],
      treeDataDesc: ''
    }
  },
  computed: {
    enableinput () {
      const { fieldconfig = {} } = this.data
      const { enableinput = 1 } = fieldconfig
      return enableinput
    },
    options () {
      const { children = [] } = this.data
      return children || []
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  created () {
    // let instance = this.$createSelectTreePop()
    // let instance = SelectTreePop.$create()
    const { fieldvalue = {} } = this.data || {}
    const { treedata = [] } = fieldvalue
    this.defaultVal = treedata
    // this.getTreeDataDesc()
    this.data.rules.custom = this.validateSeletTree
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    showSelectTreePicker () {
      /* this.instance = SelectTreePop.$create({
        $props: {
          options: this.options,
          defaultValue: this.treedata
        },
        $attrs: {
          ref: 'selectTreePicker'
        },
        $class: {
          'selectTreePicker': true
        },
        $events: {
          select: this.selectTreeHandler,
          cancel: this.cancelHandler,
          confirm: this.confirmHandler
        }
      })
      this.instance && this.instance.show() */
      this.$refs.selectTreePicker && this.$refs.selectTreePicker.show()
    },
    getTreeDataDesc () {
      let arr = this.selectedList.map(item => item.name)
      let str = arr.join(',') || ''
      this.treeDataDesc = str
    },
    setTreeValue (ids) {
      let res = []
      if (!ids || !ids.length) return res

      for (let id of ids) {
        this.setChild(res, id, this.data)
      }
      return res
    },
    setChild (res, id, data) {
      for (let i in data) {
        let item = data[i]
        if (parseInt(id) === item.id) {
          this.$set(item, 'checked', true)
          res.push(item)
          this.$forceUpdate()
        }
        item.child = item.child || item.children || item.options
        if (item.child) {
          this.setChild(res, id, item.child)
        }
      }
    },
    defaultHandler (selectedList = []) {
      this.selectedList = selectedList
      this.getTreeDataDesc()
    },
    cancelHandler (selectedVal, selectedList = []) {
      this.defaultVal = selectedVal
      this.selectedList = selectedList
      this.data.fieldvalue.treedata = selectedVal
      this.$emit('change', this.data.fieldvalue)
      this.$refs.formItem && this.$refs.formItem.validate(this.validateSeletTree)
    },
    confirmHandler (selectedVal, selectedList = []) {
      this.defaultVal = selectedVal
      this.selectedList = selectedList
      this.data.fieldvalue.treedata = selectedVal
      this.$emit('change', this.data.fieldvalue)
      this.getTreeDataDesc()
      this.$refs.formItem && this.$refs.formItem.validate(this.validateSeletTree)
    },
    handleInput (val) {
      // this.data.fieldvalue.input = val.trim()
      this.data.fieldvalue.input = val
      this.$emit('change', this.data.fieldvalue)
      this.$refs.formItem && this.$refs.formItem.validate(this.validateSeletTree)
    },
    validateSeletTree () {
      let { fieldname = '', fieldvalue = {}, fieldconfig = {}, isneeded } = this.data
      let { treedata = [], input = '' } = fieldvalue
      let { enableinput } = fieldconfig

      if (!isneeded) return true
      if ((enableinput && input) || (treedata.length)) {
        return true
      } else {
        this.data.messages.custom = this.$t('message["848"]') + fieldname
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-tree ::v-deep {
  flex: 1;
  .cube-input-field::-webkit-input-placeholder {
    color: #d6d6d6;
  }
  .cube-input-field {
    height: 56px;
  }
}
.tree-data-desc {
  flex: 1;
  display: flex;
  justify-content: space-between;
  color: #d6d6d6;
  .name {
    line-height: 1;
    align-self: center;
  }

  .iconfont {
    color: #d6d6d6;
  }
}
</style>
